import { colors } from 'theme'
import { dashboardStatusColors } from 'theme/dashboardStatusColors'

export const defaultThemeStyles = {
    online: dashboardStatusColors.online,
    offline: dashboardStatusColors.offline,
    error: dashboardStatusColors.error,
    updating: colors.warning,
    notSynchronized: colors.notSynchronized,
    sleep: dashboardStatusColors.sleep,
}
